/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { mapToResource, ResourceRepository, ResourceSearchService, SearchResourceServiceConfig } from '@common/tech-shared';
import { VorgangResource, VorgangService, VorgangWithEingangLinkRel } from '@alfa-client/vorgang-shared';
import { UserProfileListResource, UserProfileResource } from './user-profile.model';

export class UserProfileResourceSearchService extends ResourceSearchService<
  VorgangResource,
  UserProfileListResource,
  UserProfileResource
> {}

export function createUserProfileResourceSearchService(repository: ResourceRepository, vorgangService: VorgangService) {
  return new ResourceSearchService(buildConfig(vorgangService), repository);
}

function buildConfig(vorgangService: VorgangService): SearchResourceServiceConfig<VorgangResource> {
  return {
    baseResource: vorgangService.selectVorgangWithEingang().pipe(mapToResource<VorgangResource>()),
    searchLinkRel: VorgangWithEingangLinkRel.SEARCH_USER_PROFILES,
  };
}
